import { ErrorMessage } from "@hookform/error-message";
import moment from "moment";
import { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { Col, Form, Input, Modal, ModalBody, Row } from "reactstrap";
import { Button, RSelect } from "../../../components/Component";
import { NumericFormat } from "react-number-format";
import { POST } from "../../../helper/api";

const VAT_PERCENT_OPTIONS = [
  { label: "KKKNT", value: "KKKNT" },
  { label: "0%", value: 0 },
  { label: "5%", value: 5 },
  { label: "8%", value: 8 },
  { label: "10%", value: 10 },
];

export function ModalPnBillVAT({ amount, selectedBillIds, onCancel, onSuccess }) {
  const [loading, setLoading] = useState(false);
  const { errors, handleSubmit, control, setValue } = useForm({
    defaultValues: {
      vatPercent: 10,
      vatAmount: Math.round(amount / 100 * 10),
      createdAt: moment().format("YYYY-MM-DD HH:mm:ss"),
      note: "",
    },
  });

  const onFormSubmit = (data) => {
    const vatPercent = data.vatPercent === "KKKNT" ? 0 : data.vatPercent;
    const vatRateName = VAT_PERCENT_OPTIONS.find((c) => c.value === data.vatPercent)?.label || "";
    setLoading(true);
    POST(
      `/pn-bill/create-bill-vat`,
      {
        pnBillIds: selectedBillIds,
        vatPercent,
        vatRateName,
        note: data.note,
        createdAt: data.createdAt,
      },
      {},
      true
    )
      .then(() => {
        toast.success("Tạo hóa đơn VAT thành công");
        onSuccess();
      })
      .catch(({ response }) => {
        toast.error(response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại.");
      })
      .finally(() => setLoading(false));
  };

  return (
    <Modal isOpen={true} toggle={() => onCancel()}>
      <ModalBody className="modal-body-lg text-center">
        <Form className="is-alter" onSubmit={handleSubmit(onFormSubmit)}>
          <div className="nk-modal">
            <Row className="g-3 text-left">
              <Col md="12">
                <div className="form-group">
                  <label className="form-label">
                    Ngày tạo <span className="text-danger">*</span>
                  </label>
                  <div className="form-control-wrap">
                    <Controller
                      control={control}
                      name="createdAt"
                      rules={{ required: "Vui lòng nhập thông tin" }}
                      render={({ onChange, value }) => (
                        <Input
                          type="datetime-local"
                          value={value}
                          onChange={(e) => onChange(e.target.value)}
                        />
                      )}
                    />
                    <ErrorMessage
                      errors={errors}
                      name="createdAt"
                      render={({ message }) => <span className="invalid">{message}</span>}
                    />
                  </div>
                </div>
              </Col>

              <Col md="12">
                <div className="form-group">
                  <label className="form-label">Tổng doanh thu (đ)</label>
                  <div className="form-control-wrap">
                    <NumericFormat
                      disabled
                      className="form-control"
                      type="text"
                      value={amount}
                      thousandsGroupStyle="thousand"
                      thousandSeparator=","
                      suffix=" đ"
                      decimalScale={0}
                    />
                  </div>
                </div>
              </Col>

              <Col md="12">
                <div className="form-group">
                  <label className="form-label">
                    Phần trăm VAT(%) <span className="text-danger">*</span>
                  </label>
                  <div className="form-control-wrap">
                    <Controller
                      control={control}
                      name="vatPercent"
                      rules={{ required: "Vui lòng nhập thông tin" }}
                      render={({ onChange, value, name, ref }) => (
                        <RSelect
                          classNamePrefix="form-control"
                          inputRef={ref}
                          name={name}
                          options={VAT_PERCENT_OPTIONS}
                          value={VAT_PERCENT_OPTIONS.find((c) => c.value === value)}
                          onChange={(val) => {
                            onChange(val.value);
                            const realVatPercent = val.value === "KKKNT" ? 0 : val.value;
                            setValue("vatAmount", Math.round(amount / 100 * realVatPercent));
                          }}
                        />
                      )}
                    />
                    <ErrorMessage
                      errors={errors}
                      name="vatPercent"
                      render={({ message }) => <span className="invalid">{message}</span>}
                    />
                  </div>
                </div>
              </Col>

              <Col md="12">
                <div className="form-group">
                  <label className="form-label">
                    Tổng tiền VAT (đ) <span className="text-danger">*</span>
                  </label>
                  <div className="form-control-wrap">
                    <Controller
                      control={control}
                      name="vatAmount"
                      rules={{ required: "Vui lòng nhập thông tin" }}
                      render={({ onChange, value, ref }) => (
                        <NumericFormat
                          className="form-control"
                          getInputRef={ref}
                          type="text"
                          value={value}
                          thousandsGroupStyle="thousand"
                          thousandSeparator=","
                          decimalScale={0}
                          onValueChange={(val) => onChange(val.floatValue)}
                        />
                      )}
                    />
                    <ErrorMessage
                      errors={errors}
                      name="vatAmount"
                      render={({ message }) => <span className="invalid">{message}</span>}
                    />
                  </div>
                </div>
              </Col>

              <Col md="12">
                <div className="form-group">
                  <label className="form-label">Ghi chú</label>
                  <div className="form-control-wrap">
                    <Controller
                      control={control}
                      name="note"
                      render={({ onChange, value }) => (
                        <Input value={value} onChange={(e) => onChange(e.target.value)} />
                      )}
                    />
                  </div>
                </div>
              </Col>
            </Row>

            <div className="nk-modal-action mt-5 d-flex justify-content-around">
              <Button
                type="button"
                color="light"
                size="lg"
                className="btn-mw mr-5"
                onClick={() => onCancel()}
                disabled={loading}
              >
                Huỷ bỏ
              </Button>
              <Button color="primary" size="lg" className="btn-mw" type="submit" disabled={loading}>
                Xác nhận
              </Button>
            </div>
          </div>
        </Form>
      </ModalBody>
    </Modal>
  );
}
